module.exports = __webpack_public_path__ + "img/dealsandconfirm-blue.a4b7929a.svg";